import Form, { FormProps } from "@/shared/form/form";
import Input from "@/shared/form/input";
import { LocalizedValue } from "@/shared/form/localized-value";
import InputNumber from "@/shared/form/input-number";
import { EntitySelectView } from "@/modules/dynamic-attributes/feature/dynamic-attribute-entity-select";
import { SubmitButton, SubmitWrapper } from "@/shared/form/button";
import { useTranslations } from "use-intl";
import { FieldsType } from "../model/types";

type GroupFormViewProps = FormProps<FieldsType>;

export function GroupFormView({ ...formProps }: GroupFormViewProps) {
  const t = useTranslations("GroupFormView");

  return (
    <Form {...formProps} layout="vertical">
      <Form.Item<FieldsType> name="id" hidden>
        <Input />
      </Form.Item>

      <LocalizedValue
        label={t("Name")}
        myLocaleRules={[{ required: true }]}
        name="name"
        render={({ placeholder }) => <Input placeholder={placeholder} />}
      />

      <Form.Item<FieldsType> name="order" label={t("Order")}>
        <InputNumber className="!w-full" placeholder={t("Choose order")} />
      </Form.Item>

      <Form.Item<FieldsType>
        hidden
        name="dynamicAttributeEntity"
        label={t("Entity")}
        rules={[{ required: true }]}
      >
        <EntitySelectView disabled />
      </Form.Item>

      <SubmitWrapper>
        <SubmitButton />
      </SubmitWrapper>
    </Form>
  );
}
